import { defineAsyncComponent } from 'vue'
export default {
  "client-height": defineAsyncComponent(() => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/layouts/client-height.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/layouts/default.vue").then(m => m.default || m))
}